"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var legacy_1 = require("satcheljs/lib/legacy");
var signoutUrl = '/owa/logoff.owa';
exports.signout = legacy_1.action('signout')(function signout() {
    var userConfiguration = getUserConfiguration_1.default();
    if (userConfiguration.ApplicationSettings.CloseWindowOnLogout) {
        // TODO: Task 644 - Put up message box saying to sign out by closing all windows.
        // Only needed for on-prem
    }
    location.assign(signoutUrl);
});
//# sourceMappingURL=signout.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/actions/signout.js
// module id = 6211
// module chunks = 38